import { WorkingCenterShift4DeviceModelType } from '@teinor/erp/types/company/workingCenter/workingCenterShift4Device'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean, DeleteRow, EditRow } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import ModalCEWorkingCenterShift4Device from './ModalCEWCShift4Device'
import ModalDeleteWorkingCenterShift4Device from './ModalDeleteWCShift4Device'

interface WorkingCenterShift4DevicesProps extends ComponentWithPermissions {
    basicData: WorkingCenterModelType | null
}

const WorkingCenterShift4Devices: React.FC<WorkingCenterShift4DevicesProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('shift4Devices', 'Dispositivos Shift4'),
        newText: t('addDevice', 'Nuevo dispositivo'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableWorkingCenterShift4Devices} CreateModalComponent={ModalCEWorkingCenterShift4Device} EditModalComponent={ModalCEWorkingCenterShift4Device} DeleteModalComponent={ModalDeleteWorkingCenterShift4Device} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ WorkingCenterId: basicData?.id }} basicData={basicData || {}}/>
    )
}
interface TableWorkingCenterShift4DevicesProps extends TableComponentBaseScreenInnerProps {
    className?: string
    name?: string
    hideLoadFiltersButton?: boolean
}

export const TableWorkingCenterShift4Devices: React.FC<TableWorkingCenterShift4DevicesProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams, ...rest }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<WorkingCenterShift4DeviceModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: {
                    items: {
                        'true': { name: t('actived', 'Activados') },
                        'false': { name: t('disabled', 'Desactivados') },
                        'all': { name: t('all', 'Todos') }
                    }, label: t('active', 'Activo')
                }
            },
            searchKey: 'active',
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                const icon = !allRowData?.active ? faRotateLeft : undefined
                return <DeleteRow key={'delete' + parameterValue} {...{ icon, parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        },
    ]
    return (
        <TwinTable columns={columns} name='workingCenterShift4Devices' getDataFrom='/api/app/workingCenter/workingCenterShift4Device/getAllWorkingCenterShift4Devices' extraWhereParams={extraWhereParams} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} {...rest} />
    )
}
export default WorkingCenterShift4Devices